import {
  AbpApplicationConfigurationService,
  ConfigStateService,
  PermissionService,
} from '@abp/ng.core';
import { Component, ElementRef, OnInit } from '@angular/core';
import { HttpErrorComponent } from '@volo/abp.ng.theme.lepton';

@Component({
  selector: 'cai-custom-http-error',
  templateUrl: './custom-http-error.component.html',
  standalone: false,
})
export class CustomHttpErrorComponent extends HttpErrorComponent implements OnInit {
  constructor(
    private abpApplicationConfigurationService: AbpApplicationConfigurationService,
    private config: ConfigStateService,
    private permissionService: PermissionService,
    private elementRef: ElementRef<HTMLElement>,
  ) {
    super();
  }

  ngOnInit() {
    const currentWrapper = this.elementRef.nativeElement.closest('abp-http-error-wrapper');
    if (!currentWrapper) {
      return;
    }

    document.querySelectorAll('abp-http-error-wrapper').forEach((wrapper) => {
      if (wrapper !== currentWrapper) {
        wrapper.remove();
      }
    });
  }

  goHome() {
    this.abpApplicationConfigurationService.get({ includeLocalizationResources: true }).subscribe({
      next: (config) => {
        this.config.setState(config);
        const isAuthorized = this.permissionService.getGrantedPolicy('Designer.Projects');

        if (isAuthorized) {
          this.router.navigateByUrl('/projects');
        } else {
          this.router.navigateByUrl('/');
        }
      },
      error: () => {
        this.router.navigateByUrl('/');
      },
    });

    this.elementRef.nativeElement.closest('abp-http-error-wrapper')?.remove();
  }
}
